// extracted by mini-css-extract-plugin
module.exports = {"carousel":"bg_Q","bullet":"bg_c5","bulletTitle":"bg_c6"};